<template>
  <div class="expert" style="min-height:35vw">
    <div class="container clearf">
      <div class="left-box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>农业专家</el-breadcrumb-item>
        </el-breadcrumb>
        <ul class="expert-list" v-for="(item, index) in content" :key="index">
          <li class="expert-des" @click="problemClick(item)">
            <img v-if="item.coverUrl" :src="$img + item.coverUrl" />
            <img v-if="!item.coverUrl" src="/static/img/expert.jpg" alt="" />
            <ul class="ul-right">
              <li>
                <span class="txt">姓名:</span>
                <span>{{ item.realname }}</span>
              </li>
              <li>
                <span class="txt">学历:</span>
                <span>{{ item.education || "暂无" }}</span>
              </li>
              <li>
                <div class="txt">简介:</div>
                <span class="txt-brief">{{ item.introduction }}</span>
              </li>
            </ul>
          </li>
        </ul>

        <!-- 分页 -->
        <div class="pagings" v-if="content.length > 0">
          <span class="demonstration"></span>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-size="10"
            layout="total, prev, pager, next,jumper"
            :total="Datas.totalElements"
          ></el-pagination>
        </div>
      </div>
      <div class="right-box">
        <recommendation />
      </div>
    </div>
  </div>
</template>

<script>
import recommendation from "../components/recommendation";
export default {
  data() {
    return {
      recommendation: "",
      pageSize: "10",
      pageNum: "1",
      content: [],
      currentPage1: 0,
      Datas: ""
    };
  },
  mounted() {
    this.getPage();
  },
  methods: {
    getPage(e) {
      let pageSize = this.pageSize;
      let pageNum = this.pageNum;
      const data = {
        pageNum: pageNum,
        pageSize: pageSize
      };
      this.$api.experApi
        .expertList(data)
        .then(res => {
          console.log(res);
          this.Datas = res.data.respData;
          this.content = res.data.respData.content;
          this.respData = res.data.respData;
        })
        .catch(err => {
          console.log(err);
        });
    },
    problemClick(item) {
      let tid = item.tid;
      this.$router.push({
        path: "/expertDetail",
        query: {
          tid: tid
        }
      });
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getPage();
      this.pageNum = "1";
    }
  },
  components: {
    recommendation
  }
};
</script>

<style lang="less">
.expert-des {
  width: 848px;
  padding: 20px;
  margin-top: 20px;
  background: #fff;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  justify-content: flex-start;

  img {
    width: 150px;
    height: 180px;
    background-color: #f0f0f0;
    border-radius: 12px;
    object-fit: contain;
  }
  .ul-right {
    padding-left: 20px;
    li {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      padding-bottom: 10px;
      .txt {
        width: 50px;
        color: #149508;
      }
      .txt-brief {
        width: 590px;
        line-height: 30px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
  }
}
.el-breadcrumb {
  background-color: #fff;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  padding: 0 15px;
}
.el-breadcrumb__inner.is-link {
  color: #333;
  font-weight: normal;
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #149508;
}
.el-breadcrumb__separator {
  color: #333;
}
.left-box {
  float: left;
  width: 848px;
  margin-top: 20px;
}
.right-box {
  float: right;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/expert.vue